import { Component } from "react";
import { AuthButton } from './AuthButtons';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faAddressCard } from '@fortawesome/free-solid-svg-icons';
import { withAuth0 } from '@auth0/auth0-react';

class UserMenu extends Component {
  render() {
    const {user, isAuthenticated } = this.props.auth0;
    // console.log("🚀 ~ file: UserMenu.js ~ line 11 ~ UserMenu ~ render ~ user", user);
    return (
      <div className="flex justify-center">
        <div>
          <div className="dropdown relative">
            
            <button
              className="dropdown-toggle px-6 font-bold text-base leading-tight uppercase rounded transition duration-150 ease-in-out flex items-center whitespace-nowrap"
              type="button"
              id="dropdownMenuButton2"
              data-bs-toggle="dropdown"
              aria-expanded="false">
              <FontAwesomeIcon icon={faUser} size='lg'/>
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="caret-down"
                className="w-2 ml-2"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
              >
                <path
                  fill="currentColor"
                  d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                ></path>
              </svg>
            </button>
            <ul
              className="dropdown-menu min-w-max absolute hidden bg-white text-base z-50 float-left py-2 list-none text-right rounded-lg shadow-lg bg-clip-padding border-none"
              aria-labelledby="dropdownMenuButton2">
              {isAuthenticated &&
                <li className="relative text-md py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700 hover:bg-gray-100">
                    Welcome, {user.name}
                </li>
              }
              <li className="relative text-md py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700 hover:bg-gray-100">
                <Link to='/Profile' className="w-32 h-full">
                  Profile <FontAwesomeIcon className='mx-1' icon={faAddressCard} size='lg'/>
                </Link>
              </li>
              <li className="text-md py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700 hover:bg-gray-100">
                <AuthButton
                  className="dropdown-item text-md py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700 hover:bg-gray-100"
                  href="#">
                </AuthButton>
              </li>
            </ul>
          </div>
        </div>
      </div>

    );
  }

}

export default withAuth0(UserMenu);